// _gsap.js

export function initGSAP() {
    // Enregistrez les plugins que vous allez utiliser
    gsap.registerPlugin(
      ScrollTrigger,
      Flip,
      Observer,
      ScrollToPlugin,
      Draggable,
      MotionPathPlugin,
      EaselPlugin,
      PixiPlugin,
      TextPlugin
    );
  
    // Vous pouvez également initialiser des configurations globales ici si nécessaire
    // Par exemple :
    // ScrollTrigger.defaults({
    //   toggleActions: "restart pause resume pause"
    // });
  }
  
  // Fonction utilitaire pour obtenir l'instance gsap
  export function getGSAP() {
    return gsap;
  }